/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { useDependencies } from '../../contexts/dependencies.context';
import type { ICapacityEvaluationRepository } from '../../domain/repositories/capacity-evaluation.repository';
import { GetAllJobs } from '../queries/capacity-evalution/get-all-jobs';

export namespace CreateCapacityEvaluation {
  export type Input = ICapacityEvaluationRepository.CreateInput;
  export type Output = ICapacityEvaluationRepository.CreateOutput;

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const { repositories } = useDependencies();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn: (input) => repositories.capacityEvaluation.create(input),
      async onSuccess(_, input) {
        await queryClient.invalidateQueries({
          queryKey: GetAllJobs.key({ siteId: input.data.assetId }),
        });
      },
    });
  }
}
